import {convertToUrlParams} from 'utils'
import baseApi, {provideTag} from './baseApi'

const faultLogApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getFaultLogs: build.query({
            query: (query) => {
                const params = convertToUrlParams(query)
                return {
                    url: `faultLog${params}`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: () => provideTag('FaultLog'),
        }),
        getFaultLog: build.query({
            query: (id) => {
                return {
                    url: `faultLog/${id}`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: (result) => provideTag('FaultLog', result),
        }),
        deleteFaultLog: build.mutation({
            query: (id) => {
                return {
                    url: `faultLog/${id}`,
                    method: 'DELETE',
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['FaultLog'],
        }),
        createFaultLog: build.mutation({
            query: (data) => {
                return {
                    url: `faultLog`,
                    method: 'POST',
                    body: data,
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['FaultLog'],
        }),
        resolveFaultLog: build.mutation({
            query: (id) => {
                return {
                    url: `faultLog/${id}/resolve`,
                    method: 'PUT',
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['FaultLog'],
        }),
    }),
    overrideExisting: false,
})

export default faultLogApi

export const {
    useGetFaultLogsQuery,
    useGetFaultLogQuery,
    useDeleteFaultLogMutation,
    useCreateFaultLogMutation,
    useResolveFaultLogMutation,
} = faultLogApi
